export default __webpack_public_path__ + "static/media/home-lamine.aaf52594.png";